(function() {
  const EXPIRATION_DAYS = 7;

  function isFlagExpired() {
    const item = localStorage.getItem("dkpsuleur_visited");
    if (!item) return true;
    try {
      const data = JSON.parse(item);
      if (!data.timestamp) return true;
      const now = Date.now();
      const diff = now - data.timestamp;
      return diff > EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
    } catch {
      return true;
    }
  }

  function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function isConnectionSlow() {
    if ('connection' in navigator) {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn) {
        return ['slow-2g', '2g', '3g'].includes(conn.effectiveType);
      }
    }
    return false;
  }

  if (isFlagExpired() && (isMobile() || isConnectionSlow())) {
    const loaderWrapper = document.createElement('div');
    loaderWrapper.id = 'loader-wrapper';
    loaderWrapper.style.position = 'fixed';
    loaderWrapper.style.top = 0;
    loaderWrapper.style.left = 0;
    loaderWrapper.style.width = '100vw';
    loaderWrapper.style.height = '100vh';
    loaderWrapper.style.backgroundColor = '#000';
    loaderWrapper.style.display = 'flex';
    loaderWrapper.style.alignItems = 'center';
    loaderWrapper.style.justifyContent = 'center';
    loaderWrapper.style.zIndex = '9999';
    loaderWrapper.style.transition = 'opacity 0.5s ease';

    const img = document.createElement('img');
    img.src = "https://cdn.shopify.com/s/files/1/0913/2035/3112/files/apple-touch-icon.png?v=1748337066";
    img.alt = "Chargement DKpsuleur";
    img.style.width = '200px';
    img.style.height = '200px';
    img.style.animation = 'pulse 1.8s ease-in-out infinite';

    loaderWrapper.appendChild(img);
    document.body.appendChild(loaderWrapper);

    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0%, 100% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.07); opacity: 0.7; }
      }
    `;
    document.head.appendChild(style);

    window.addEventListener('load', function() {
      loaderWrapper.style.opacity = '0';
      setTimeout(() => {
        loaderWrapper.remove();
        localStorage.setItem("dkpsuleur_visited", JSON.stringify({ timestamp: Date.now() }));
      }, 500);
    });
  }
})();
